// extracted by mini-css-extract-plugin
export default {"wrapper":"GameRulesContent_wrapper__xCrGL"};